import React from "react";
import { useRef } from 'react'
import QRCode from "qrcode.react";


// 共通QRコード
const ModalInterviewSetupUrl = (props) => {
    const buttonEl = useRef(null);
    
    function copyButton() {
      if (window.clipboardData){ // IE対応
        window.clipboardData.setData("Text" ,`https://${location.hostname}/${props.institution_key}/interview/setup`);
      } else {
        navigator.clipboard.writeText(`https://${location.hostname}/${props.institution_key}/interview/setup`);
      }
    }

    function jumpQrCodePage() {
        location.href = (`/interview/qr_code`)  
    }

    return (
      <>
        <div className="modal fade" data-backdrop="static" id="modalInterviewSetupUrl">
          <div className="modal-dialog modal-width">
            <div className="modal-content">
              <div className="modal-header bg-success">
                <button type="button" className="close" data-dismiss="modal" ref={buttonEl}>
                  <span aria-hidden="true">&#215;</span><span className="sr-only">閉じる</span>
                </button>
                <h4 className="modal-title text-center modal-title-align">
                  共通QRコード
                </h4>
              </div> {/* /modal-header */}

              <div className="modal-body interview-status-modal-body">
                <div className="form-group">
                  <input
                    key="clipboard"
                    type="text"
                    className="form-control"
                    readOnly={true}
                    value={`https://${location.hostname}/${props.institution_key}/interview/setup`}
                  />
                  <button type="button" className="interview-link-modal-button" onClick={() => copyButton()} style={{marginRight: "10px"}}>
                    コピー
                  </button>
                </div>

                <hr style={{width: "400px"}} />

                <div className="form-group">
                  <div>QRコードを読み取ってください</div>
                  <QRCode value={`https://${location.hostname}/${props.institution_key}/interview/setup`} size="200"/>
                </div>

                <hr style={{width: "400px"}} />

                <div className="form-group">
                  <button type="button" className="pager-button bg-white" onClick={() => jumpQrCodePage()}>QRコード印刷用ページを表示する</button>
                </div>

                <hr style={{width: "400px"}} />
              </div> {/* /modal-body */}
            </div> {/* /modal-content */}
          </div> {/* /modal-dialog */}
        </div> {/* /modal */}

        <input id="send_complate_button" type="hidden"　data-toggle="modal" data-target="#send_complate_modal"/>
        <input id="send_error_button" type="hidden" data-toggle="modal" data-target="#send_error_modal"/>
        
      </>
    );
};

export default ModalInterviewSetupUrl;